import { render, staticRenderFns } from "./lead_list.vue?vue&type=template&id=2cd73019"
import script from "./lead_list.vue?vue&type=script&lang=js"
export * from "./lead_list.vue?vue&type=script&lang=js"
import style0 from "./lead_list.vue?vue&type=style&index=0&id=2cd73019&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports